import gql from 'graphql-tag';
import { createBatchedFetcher as createBatchedGqlFetcher } from '../lib/gqlFetcher';
import { createBatchedFetcher as createBatchedMyf2bFetcher } from '../lib/gqlFetcher_myf2b';

const gql_fetcher = createBatchedGqlFetcher(1000, 50);
const myf2b_fetcher = createBatchedMyf2bFetcher(1000, 50);
export { gql_fetcher, myf2b_fetcher };

const extractValue = (data) => typeof data !== 'object' ? !!data : (
	Object.entries(data).some(([k, v]) => k !== '__typename' && extractValue(v))
);

const buildGqlQuery = (name, vars, field, fetcher = gql_fetcher) => {
	const varsEntries = Object.entries(vars);
	const varsFragment = varsEntries.length === 0 ? '' : `(${varsEntries.map(([k, v]) => `$${k}: ${v}`).join(', ')})`;
	const query = gql`query ACCESS_CONTROL__${name}${varsFragment}{ ${field} }`;
	return (
		async (_, varsValues) => extractValue(await fetcher({ document: query, variables: varsValues }))
	);
}
export default buildGqlQuery;
